import PathTemplate from "../template/PathTemplate";
import PathTemplatePattern from "../template/PathTemplatePattern";
import PatternFallDown2Side1 from "../template/PatternFallDown2Side1";
import PatternJumpDown1Side2 from "../template/PatternJumpDown1Side2";
import PatternJumpDown1Side3 from "../template/PatternJumpDown1Side3";
import PatternJumpDown1Side4 from "../template/PatternJumpDown1Side4";
import PatternJump0Side2 from "../template/PatternJump0Side2";
import PatternJump0Side3 from "../template/PatternJump0Side3";
import PatternJump0Side4 from "../template/PatternJump0Side4";
import PatternJumpUp1Side2 from "../template/PatternJumpUp1Side2";
import PatternJumpUp1Side3 from "../template/PatternJumpUp1Side3";
import PatternWalkSide2 from "../template/PatternWalkSide2";
import PatternWalkSide4 from "../template/PatternWalkSide4";
import PathPlan from "./PathPlan";
import PathPlanFallDown from "./PathPlanFallDown";
import PathPlanJumpUp from "./PathPlanJumpUp";
import PathPlanWalkLeft from "./PathPlanWalkLeft";
import PathPlanWalkRight from "./PathPlanWalkRight";
import PatternJumpUp1Side1 from "../template/PatternJumpUp1Side1";
import PatternJumpUp2Side3 from "../template/PatternJumpUp2Side3";
import PatternJumpUp2Side2 from "../template/PatternJumpUp2Side2";
import PatternJumpUp2Side1 from "../template/PatternJumpUp2Side1";
import PatternJumpDown2Side3 from "../template/PatternJumpDown2Side3";
import PatternJumpUp2 from "../template/PatternJumpUp2";
import PatternJumpUp3 from "../template/PatternJumpUp3";
import PatternFallDown2 from "../template/PatternFallDown2";
import PatternFallDown3 from "../template/PatternFallDown3";
import PathPlanMineAndWalkLeft from "./PathPlanMineAndWalkLeft";
import PathPlanMineAndWalkRight from "./PathPlanMineAndWalkRight";
import TileMinedLogic from "../../../logic/TileMinedLogic";
import PathPlanMineAndJumpUp from "./PathPlanMineAndJumpUp";
import PathPlanMineAndFallDown from "./PathPlanMineAndFallDown";
import Path from "../Path";
import PatternFallDown4 from "../template/PatternFallDown4";
import PatternFallDown5 from "../template/PatternFallDown5";
import PatternWalkSide4Negligible from "../template/PatternWalkSide4Negligible";
import PatternWalkSide3Negligible from "../template/PatternWalkSide3Negligible";
import PatternWalkSide2Negligible from "../template/PatternWalkSide2Negligible";
import PatternWalkSide5Negligible from "../template/PatternWalkSide5Negligible";
import PatternJumpDown1Side2Negligible from "../template/PatternJumpDown1Side2Negligible";
import PatternJumpUp1Side2Negligible from "../template/PatternJumpUp1Side2Negligible";

export default class PathPlanEvaluator {
    /**
     * 
     * @param {TileMinedLogic} tileMinedLogic 
     */
    constructor(tileMinedLogic) {

        /**
         * @constant
         * @type {TileMinedLogic}
         */
        this.tileMinedLogic = tileMinedLogic;

        /**
         * @constant
         * @private
         * @type {PathTemplate}
         */
        this.pathTemplate = new PathTemplate();

        /**
         * @constant
         * @private
         * @type {Array.<PathTemplatePattern>}
         */
        this.patterns = [
            /////////////////////////////////
            // 4/5-Tile jumps
            /////////////////////////////////

            new PatternFallDown5(),        // fall down 5 tiles
            new PatternFallDown4(),        // fall down 4 tiles

            /////////////////////////////////
            // 3-Tile jumps
            /////////////////////////////////

            new PatternJump0Side4(),        // 3-tile jump across horizontal gap
            new PatternJumpDown1Side4(),    // 3-tile jump across gap, down one tile step
            new PatternJumpUp2Side3(),      // jump up 2 tiles, across 3.
            new PatternJumpDown2Side3(),    // jump down 2 tiles, across 3

            /////////////////////////////////
            // 2-tile jumps
            /////////////////////////////////

            new PatternJump0Side3(),        // 2-tile jump across horizontal gap
            new PatternJumpUp1Side3(),      // 2-tile jump across gap, up one tile step
            new PatternJumpDown1Side3(),    // 2-tile jump across gap, down one tile step
            new PatternJumpUp2Side2(),      // jump up 2 tile step, across 2
            new PatternJumpUp3(),           // jump up 3 tiles
            new PatternFallDown3(),         // fall down 3 tiles

            /////////////////////////////////
            // 1-tile jumps
            /////////////////////////////////

            new PatternJump0Side2(),        // Jump over gap (1 open tiles)
            new PatternJumpUp2Side1(),      // Jump up 2, across 1.
            new PatternJumpUp1Side2(),      // Jump up one step, one tile away
            new PatternJumpDown1Side2(),    // 1-tile jump across gape, down one tile stap.
            new PatternJumpUp1Side1(),      // 1-tile jump a step.        
            new PatternJumpUp2(),           // jump up 2 tiles.
            new PatternFallDown2(),         // fall down 2 tiles.

            new PatternFallDown2Side1(),    // Fall off edge

            new PatternWalkSide4(),        // Walk straight long
            new PatternWalkSide2()         // Walk straight short
        ];

        /**
         * @constant
         * @private
         * @type {Array.<PathTemplatePattern>}
         */
        this.patternsTileHealthNegligible = [

            new PatternFallDown5(),        // fall down 5 tiles
            new PatternFallDown4(),        // fall down 4 tiles
            new PatternFallDown3(),         // fall down 3 tiles
            new PatternFallDown2(),         // fall down 2 tiles.

            new PatternWalkSide5Negligible(),
            new PatternWalkSide4Negligible(),  // Walk straight long
            new PatternWalkSide3Negligible(),
            new PatternWalkSide2Negligible(),

            new PatternJumpDown1Side2Negligible(),    // 1-tile jump across gape, down one tile stap.
            
            new PatternJumpUp2Side2(),      // jump up 2 tile step, across 2
            new PatternJumpUp1Side2Negligible(),
            new PatternJumpUp1Side1(),      // 1-tile jump a step.        

        ];

        /**
         * Reuse the claimed path array instead of reallocating it over and over.
         * @constant
         * @private
         * @type {Array.<PathPlan>}
         */
        this.claimedPath = new Array(30);
        this.claimedPath.fill(null);
    }

    /**
     * Connect the path to the existing plan.
     * @param {Path} path
     * @param {Array.<PathPlan>} pathPlan
     * @param {number} startIndex Where the path starts in the existing path plan
     * @param {boolean} tileHealthNegligible
     */
    connectPathToPlan2(path, pathPlan, startIndex, tileHealthNegligible) {
        if (path.size === 0) {
            return;
        }

        // The side-effect of this is the claimedPath
        this.evaluatePathInternal(path, tileHealthNegligible);

        // Chop off the end of the existing path plan, starting at the start index.
        pathPlan.length = startIndex;

        // In this case we just go with the new path plan.
        this.buildPathPlanFromClaimedPath(path, pathPlan, this.claimedPath);
    }

    /**
     * Evaluate the path and figure out the path plan.
     * @param {Path} path
     * @param {Array.<PathPlan>} pathPlan
     * @param {boolean} tileHealthNegligible
     */
    evaluatePath(path, pathPlan, tileHealthNegligible) {

        if (path.size === 0) {
            // Clear out the current plan.
            pathPlan.length = 0;

            return;
        }

        // The side-effect of this is the claimedPath
        this.evaluatePathInternal(path, tileHealthNegligible);

        // Clear out the current plan.
        pathPlan.length = 0;

        // Build the path plan from the claimed path
        this.buildPathPlanFromClaimedPath(path, pathPlan, this.claimedPath);
    }

    /**
     * @private
     * @param {Path} path
     * @param {Array.<PathPlan>} pathPlan
     * @param {Array.<PathPlan>} claimedPath 
     */
    buildPathPlanFromClaimedPath(path, pathPlan, claimedPath) {

        let prevPlan = null;
        for (let i = 0; i < path.size; i++) {
            const currPlan = claimedPath[i];
            if (currPlan && currPlan !== prevPlan) {
                pathPlan.push(currPlan);
            }
            prevPlan = currPlan;
        }
    }

    /**
     * @private
     * @param {Path} path
     * @param {boolean} tileHealthNegligible
     */
    evaluatePathInternal(path, tileHealthNegligible) {
        // Grow the claimed path if necessary.
        if (path.size > this.claimedPath.length) {
            this.claimedPath.length = path.size;
        }

        // Clear out the claimed path
        this.claimedPath.fill(null);

        if (path.size < 3) {
            // Don't bother making a template-based plan.
            for (let i = 0; i < path.size - 1; i++) {
                this.addDefaultPlan(path, i, this.claimedPath, tileHealthNegligible);
            }
        }
        else {
            // Update the template so it represents the portion of the world covered by the path.
            // We can use that template for pattern matching to find special cases in the path plan.
            // eg. jumping over gaps and stuff like that.
            this.pathTemplate.updateTemplate(path, tileHealthNegligible);

            // Check for mining steps.
            if (!tileHealthNegligible) {
                for (let i = 0; i < path.size - 1; i++) {
                    this.addMinePlan(path, i, this.claimedPath);
                }
            }

            if (tileHealthNegligible) {
                // Each pattern gets a chance to claim sections of the full path.
                for (let i = 0; i < this.patternsTileHealthNegligible.length; i++) {
                    this.checkPatternAgainstPath(this.patternsTileHealthNegligible[i], path, this.claimedPath);
                }
            }
            else {
                // Each pattern gets a chance to claim sections of the full path.
                for (let i = 0; i < this.patterns.length; i++) {
                    this.checkPatternAgainstPath(this.patterns[i], path, this.claimedPath);
                }
            }


            // Don't check the last index for the start of a new plan
            for (let i = 0; i < path.size - 1; i++) {
                if (!this.claimedPath[i]) {
                    this.addDefaultPlan(path, i, this.claimedPath, tileHealthNegligible);
                }
            }
        }
    }


    /**
     * @private
     * @param {PathTemplatePattern} pattern 
     * @param {Path} path 
     * @param {Array.<PathPlan>} claimedPath 
     */
    checkPatternAgainstPath(pattern, path, claimedPath) {
        let i = 0;
        while (i < path.size) {
            // Skip past any claimed path step.
            if (claimedPath[i]) {
                i++;
                continue;
            }

            const unclaimedSpaceAvailable = this.getUnclaimedSpaceAvailable(claimedPath, path.size, i);
            if (unclaimedSpaceAvailable < pattern.getMinRequiredPathSteps()) {
                i++;
                continue;
            }

            const pathPlan = this.pathTemplate.getPlanIfPatternMatch(pattern, path, i);
            if (pathPlan) {
                const steps = pathPlan.pathSteps;

                //console.log('Eval. Pattern: ' + pattern.toString() + ' Plan: ' + pathPlan.toString() + ' Steps: ' + steps);

                // If the plan claims to use 0 steps, then this is not ok.
                if (steps === 0) {
                    console.log('PathPlanEvaluator.checkPatternAgainstPath() pattern=' + pattern.toString() + ' used no steps');
                    i++;
                    continue;
                }
                
                // It's possible that the new plan will not 'fit' in the claimed path.
                // There may be only 3 unclaimed tiles in the current location and maybe
                // this plan requires 5. In this case we will have to reject the plan.
                if (steps <= unclaimedSpaceAvailable) {
                    for (let j = 0; j < steps; j++) {
                        claimedPath[i] = pathPlan;
                        i++;
                    }

                    continue;
                }
            }

            i++;
        }
    }

    /**
     * @private
     * @param {Array.<PathPlan>} claimedPath 
     * @param {number} length The path length
     * @param {number} index 
     * @returns {number}
     */
    getUnclaimedSpaceAvailable(claimedPath, length, index) {
        let count = 0;
        for (let i = index; i < length; i++) {
            if (claimedPath[i] !== null) {
                return count;
            }
            count++;
        }

        return count;
    }

    /**
     * @private
     * @param {Path} path
     * @param {number} index
     * @param {Array.<PathPlan>} claimedPath 
     * @param {boolean} tileHealthNegligible
     */
    addDefaultPlan(path, index, claimedPath, tileHealthNegligible) {
        const current = path.tiles[index];
        const next = path.tiles[index + 1];

        // If the next tile is closed, then create the special-case mine path plan.
        if (!next.open && !tileHealthNegligible) {
            this.addMinePlan(path, index, claimedPath);
            return;
        }

        let plan;
        if (current.isNeighborLeft(next)) {
            plan = new PathPlanWalkLeft(current, next, 1);
        }
        else if (current.isNeighborRight(next)) {
            plan = new PathPlanWalkRight(current, next, 1);
        }
        else if (current.isNeighborTop(next)) {
            plan = new PathPlanJumpUp(current, next, 1);
        }
        else if (current.isNeighborBottom(next)) {
            plan = new PathPlanFallDown(current, next, 1);
        }
        else {
            console.log('addDefaultPlan() neighbor is not adjacent tile');
            this.printPathDebug(path, index);
            return;
        }

        claimedPath[index] = plan;
    }

    /**
     * @param {Path} path 
     * @param {number} index 
     */
    printPathDebug(path, index) {
        console.log('DEBUG BAD INDEX: ' + index);
        for (let i = 0; i < path.size; i++) {
            if (i == 0) {
                console.log('DEBUG step=' + i + ' ' + path.tiles[i].origin.toString());
            }
            else {
                console.log('DEBUG step=' + i + ' ' + path.tiles[i].origin.toString() + ' adjacent=' + path.tiles[i].isAdjacentTo(path[i - 1]) + ' neighbor=' + path.tiles[i].isNeighborTile(path.tiles[i - 1]) + (i === index ? ' <-----' : ''));
            }
        }
    }

    /**
     * @param {PathPlan[]} pathPlan 
     * @returns {string}
     */
    pathPlanToString(pathPlan) {
        let s = '';

        for (let i = 0; i < pathPlan.length; i++) {
            s += 'i=' + i + ':' + pathPlan[i].toString() + ', ';
        }

        return s;
    }

    /**
     * @private
     * @param {Path} path
     * @param {number} index
     * @param {Array.<PathPlan>} claimedPath 
     */
    addMinePlan(path, index, claimedPath) {

        const next = path.tiles[index + 1];
        if (next.open) {
            return;
        }

        const current = path.tiles[index];

        let plan;
        if (current.isNeighborLeft(next)) {
            plan = new PathPlanMineAndWalkLeft(current, next, 1, this.tileMinedLogic);
        }
        else if (current.isNeighborRight(next)) {
            plan = new PathPlanMineAndWalkRight(current, next, 1, this.tileMinedLogic);
        }
        else if (current.isNeighborTop(next)) {
            plan = new PathPlanMineAndJumpUp(current, next, 1, this.tileMinedLogic);
        }
        else if (current.isNeighborBottom(next)) {
            plan = new PathPlanMineAndFallDown(current, next, 1, this.tileMinedLogic);
        }
        else {
            console.log('addMinePlan() neighbor is not adjacent tile');
            return;
        }

        claimedPath[index] = plan;
    }
}